import React from 'react';
import {ScrollView} from 'react-native';
import {storiesOf} from '@storybook/react-native';

import {FlexView, Spacer, Spacing} from '/component/base/Storybook';

import Large from './Large';
import Small from './Small';

storiesOf('base', module).add('Loading Indicator', () => (
  <ScrollView>
    <Spacing size={20}>
      <FlexView>
        <Spacer size={24} />
        <Small />
        <Spacer size={24} />
        <Large />
      </FlexView>
    </Spacing>
  </ScrollView>
));
